import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import {
  type LabReqField,
  type LabReqTestElement
} from '@care-portals/api-interfaces';

@Component({
  selector: 'my-health-lab-req-element',
  templateUrl: './lab-req-element.component.html',
  styleUrls: ['./lab-req-element.component.less']
})
export class LabReqElementComponent implements OnInit {
  @Input() parentId: string;
  @Input() element: LabReqTestElement;
  @Input() values: object;
  fields: Array<LabReqField> = [];
  form: FormGroup;

  constructor(private formBuilder: FormBuilder) {}

  ngOnInit(): void {
    this.element.children.forEach((child, index) => {
      this.fields.push({
        id: this.parentId + '_' + child.id,
        label: child.label,
        type: child.type,
        required: child.required ?? false,
        level: !index ? 'child' : undefined
      });
    });

    const groupItems = {};
    this.fields.forEach(field => {
      if (field.type !== 'divider') {
        Object.assign(groupItems, {
          [field.id]: [
            {
              disabled: true,
              value:
                field.type === 'string'
                  ? ''
                  : field.type === 'number'
                  ? 0
                  : null
            },
            field.required ? Validators.required : null
          ]
        });
      }
    });

    this.form = this.formBuilder.group(groupItems);
    if (this.values) {
      this.form.patchValue(this.values);
    }
  }
}
